import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';
import type { SvgIconComponent } from '@mui/icons-material';
import type { StatusChipColor } from '../theme';

interface StatCardProps {
  label: string;
  value: number | string;
  icon: SvgIconComponent;
  color?: StatusChipColor;
  loading?: boolean;
}

const COLOR_MAP: Record<StatusChipColor, string> = {
  default: '#52606d',
  success: '#2e7d32',
  warning: '#ed6c02',
  error: '#d32f2f',
  info: '#1565c0',
};

/** Thẻ số liệu thống kê dùng trong Dashboard (Tổng feature, Đã xác nhận, ...). */
export function StatCard({ label, value, icon: Icon, color = 'default', loading }: StatCardProps): JSX.Element {
  const accent = COLOR_MAP[color];
  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2.5,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        borderTop: `3px solid ${accent}`,
      }}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography variant="body2" color="text.secondary" fontWeight={600}>
          {label}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 36,
            height: 36,
            borderRadius: '50%',
            bgcolor: `${accent}1a`,
            color: accent,
          }}
        >
          <Icon fontSize="small" />
        </Box>
      </Stack>
      {loading ? (
        <Skeleton variant="text" width={64} height={40} />
      ) : (
        <Typography variant="h4" fontWeight={700}>
          {value}
        </Typography>
      )}
    </Paper>
  );
}
